
    import { Component, Prop, Vue } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';

    const editor = namespace('editor');

    @Component
    export default class OptionsFieldsComponent extends Vue {
        @Prop() value;
        @Prop() entity;
        @Prop() keyOption;
        @Prop() name;

        @editor.Mutation editComponent;

        click() {
            const component = Object.assign(this.value, { name: this.name });
            this.editComponent({ component: component, inner: true });
        }
    }
